import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { flagConversationAPI } from '../../../api/supportChat';
import SupportWidgetKeys from '../queryKeys';

const { getConversations, getConversationDetails } = SupportWidgetKeys;

const useFlagConversation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ sessionAddress, flagged }) =>
      flagConversationAPI({ sessionAddress, flagged }),
    {
      onSuccess: (data, variables) => {
        const { flagged, sessionAddress } = variables;
        message.success(
          flagged
            ? 'Conversation flagged successfully'
            : 'Conversation unflagged successfully'
        );
        // Invalidate conversations query to refetch updated data
        queryClient.invalidateQueries([getConversations]);
        // Invalidate conversation details query to refetch updated data
        queryClient.invalidateQueries([getConversationDetails, sessionAddress]);
      },
      onError: error => {
        message.error(
          error?.response?.data?.message || 'Failed to update conversation flag'
        );
      },
    }
  );

  return {
    flagConversation: mutation.mutate,
    isLoading: mutation.isLoading,
  };
};

export default useFlagConversation;
